import React, { useEffect, useState, useRef, useImperativeHandle } from 'react';
import {
  isMobileFun,
  getPrefixField,
  convertStylesStringToObject,
  GotoMall,
  getFooterCarHeight,
  scrollToAnchor,
  isSafari
} from '../../utils/obj-utils';
import temp from '../../temp/config';
import Detailss from '../../elements/InnerPageDetail';
import { getQueryVariable } from '../../utils/site-utils';
import './style.scss';
export default function Banner(props) {
  const { fields } = props;
  const isMobile = isMobileFun();
  const [flag, setFlag] = useState(false);
  const [fixflag, setFixFlag] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const scroll = () => {
    if (
      document.documentElement.scrollTop > 0 &&
      document.documentElement.scrollHeight - document.documentElement.scrollTop - document.documentElement.clientHeight - getFooterCarHeight() > 0
    ) {
      if (window.navigationPagename !== 'home' && window.navigationPagename !== 'choose' && window.navigationPagename !== 'order') {
        setFixFlag(true);
      } else {
        setFixFlag(false);
      }
    } else {
      setFixFlag(false);
    }
  };
  useEffect(() => {
    if (isMobile) {
      window.addEventListener('scroll', scroll);
      return () => {
        window.removeEventListener('scroll', scroll);
      };
    }
  }, []);
  // tabs
  useEffect(() => {
    const queryTabDefault = (value) => {
      let defaultIndex = -1;
      fields?.detailurllists.length > 0 &&
        fields?.detailurllists.map((item, index) => {
          let tabArr = item.fields?.tabname?.value.split(',').map((tItem) => tItem.toLowerCase());
          if (tabArr.includes(value)) {
            defaultIndex = index;
          }
        });
      return defaultIndex;
    };
    const timer = setTimeout(() => {
      let tab = getQueryVariable('tab');
      let defaultTabInd = queryTabDefault(fields.tabsdefault?.value?.toLowerCase());
      if (tab) {
        let tabInd = queryTabDefault(tab.toLowerCase());
        setTabIndex(tabInd < 0 ? (defaultTabInd < 0 ? tabIndex : defaultTabInd) : tabInd);
      } else {
        setTabIndex(defaultTabInd < 0 ? tabIndex : defaultTabInd);
      }
    }, 100);
    return () => {
      clearTimeout(timer);
    };
  }, []);
  return (
    fixflag && (
      <div className="FooterFixmeau_v1" style={convertStylesStringToObject(fields[`${getPrefixField('meaustyle')}`]?.value)}>
        {fields[`${getPrefixField('configbtn', isMobile)}`]?.value && (
          <div
            className="configbtn"
            style={convertStylesStringToObject(fields[`${getPrefixField('configbtnstyle', isMobile)}`]?.value)}
            dangerouslySetInnerHTML={{ __html: fields[`${getPrefixField('configbtn', isMobile)}`]?.value?.replaceHtml() }}
            onClick={() => {
              setFlag(true);
              window.Dmp.clickAction(fields?.configbtndmp?.value);
            }}
          ></div>
        )}
        {fields[`${getPrefixField('mallbtn', isMobile)}`]?.value && (
          <div
            className="mallbtn"
            style={convertStylesStringToObject(fields[`${getPrefixField('mallbtnstyle', isMobile)}`]?.value)}
            dangerouslySetInnerHTML={{ __html: fields[`${getPrefixField('mallbtn', isMobile)}`]?.value?.replaceHtml() }}
            onClick={() => {
              let include = fields?.include?.value ? JSON.parse(fields?.include?.value) : '';
              if (include && include?.userAgent == 'isSafari' && isSafari()) {
                window.open(include?.[temp.app.term]);
                window.Dmp.clickAction(fields?.mallbtndmp?.value, include?.[temp.app.term]);
              } else {
                if (fields?.mallurl?.value) {
                  GotoMall(fields?.mallurl?.value, fields?.mallbtndmp?.value, isMobile);
                }
                if (fields?.link?.value) {
                  try {
                    window.top.location.href = fields?.link?.value;
                  } catch (e) {
                    location.href = fields?.link?.value;
                  }
                  if (fields?.mallbtndmp?.value) {
                    window.Dmp.clickAction(fields?.mallbtndmp?.value, fields?.link?.value);
                  }
                }
                if (fields?.anchor?.value) {
                  window.Dmp.clickAction(fields?.mallbtndmp?.value);
                  scrollToAnchor(fields?.anchor?.value);
                }
              }
            }}
          ></div>
        )}
        {flag && (
          <Detailss
            routePath={fields?.detailurllists.length > 0 ? fields?.detailurllists[tabIndex]?.fields?.detailurl?.value : fields?.detailurl?.value}
            close={() => setFlag(false)}
          />
        )}
      </div>
    )
  );
}
